export type TabType = {
  id?: number;
  name: string;
  Component?: React.FC<any>;
  parent?: any;
  /** A list of grants, of which only 1 is needed to access the tab. */
  grants?: string[];
  label?: string;
};

export interface Header {
  subHeaderName: string;
  tabs: TabType[];
  requiredGrants?: string[];
}

const PREFIX = 'admin';

export const ADMIN_SESSION_STORAGE_KEYS = {
  LAST_LOCATION: `${PREFIX}_last_location`
};

export type SwitcherComponentProps = {
  tabbedElement: TabType;
  tabulatedItems: TabType[];
  setTabbedElement;
  page?: string;
  disableRouting?: boolean;
  showCustomMenuItemLabel?: boolean;
};
